<div class="change-password-card login-form">
    <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
        <div class="change-password-warning">
            <i class="fas fa-exclamation-triangle"></i>
            <span translate>You must change your password before continuing.</span>
        </div>
        <div class="cp-field">
            <label class="change-password-label" for="cpNewPassword"><span translate>Password</span> *</label>
            <div class="cp-input-group">
                <input id="cpNewPassword" [type]="fieldTextType ? 'text' : 'password'" formControlName="NewPassword" class="cp-input"
                    [ngClass]="{ 'is-invalid': submitted && cpf.NewPassword.errors }" autofocus>
                <button type="button" class="cp-btn-generate" (click)="generateNewPassword()" translate>Generate</button>
            </div>
        </div>
        <app-pasword-strength *ngIf="changePasswordForm" [password]="cpf.NewPassword.value || ''"></app-pasword-strength>
        <br/>
        <div class="cp-field">
            <label class="change-password-label" for="cpPasswordRepeat"><span translate>Confirm Password</span> *</label>
            <input id="cpPasswordRepeat" type="password" formControlName="PasswordRepeat" class="cp-input"
                [ngClass]="{ 'is-invalid': submitted && (cpf.PasswordRepeat.errors || changePasswordForm.errors?.doesMatchPassword) }">
            <div class="cp-error" *ngIf="submitted && cpf.PasswordRepeat.errors?.required" translate>Password is required</div>
            <div class="cp-error" *ngIf="submitted && !cpf.PasswordRepeat.errors?.required && changePasswordForm.errors?.doesMatchPassword" translate>Password does not match</div>
        </div>
        <div class="cp-error" *ngIf="errorMessage">{{ errorMessage }}</div>
        <div class="cp-submit">
            <button type="submit" class="cp-btn-submit" translate>Save</button>
        </div>
    </form>
</div>
